import loadable from '@loadable/component';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const EditOrgLinksLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "EditOrgLinks" */
      './EditOrgLinks.dynamic'
    ),
  { fallback: <LoadingPageLoadable /> },
);
